var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.portfolioData),function(item,index){return (_vm.activeTab==0 || _vm.activeTab==index+1)?_c('div',{staticClass:"rwt-gallery-area mb--20"},[_c('div',{staticClass:"container"},[_c('Gallery',{attrs:{"gallery-data":item,"column":"col-lg-4 col-md-6 col-sm-6 col-12 mt--30","data-aos":"fade-up"}})],1)]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }